import api from './api';

export function getActiveQuestions(){
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/encuestas/preguntas?activas=true`);
}

export function getAllQuestions(){
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/encuestas/preguntas?activas=false`);
}

export function getAnswersById(idQuestion){
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/encuestas/preguntas/${idQuestion}/puntajes`);
}

export function createQuestion(question){
    return api.post(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/encuestas/preguntas`, question);
}

export function updateQuestion(idQuestion, question){
    return api.patch(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/encuestas/preguntas/${idQuestion}`, question);
}

export function createAnswer(idAsesor, idQuestion, answer){
    return api.post(
        `${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/asesores/${idAsesor}/encuestas/preguntas/${idQuestion}/respuestas`
        , answer);
}

export function updateLastSurvey(idAsesor){
    const now = new Date();
    const yyyy = now.getFullYear();
    let mm = now.getMonth() + 1;
    let dd = now.getDate();
    if(dd < 10){ dd = '0' + dd; }
    if(mm < 10){ mm = '0' + mm; }
    const formattedToday = yyyy + "-" + mm + "-" + dd;
    return api.patch(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/asesores/${idAsesor}/encuestas/ultima-encuesta`, {idAsesor: idAsesor, ultimaEncuesta: now});
}

export function getScoreById(idQuestion){
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/encuestas/preguntas/${idQuestion}/puntajes`);
}

export function getLastSurvey(idAsesor){
    return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/asesores/${idAsesor}/encuestas/ultima-encuesta`);
}
